// HomeWeb.jsx
import React, { useState, useRef } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
export default function DadosCompradoresPromessaWeb({ route }) {
  const navigation = useNavigation();
  // envio unico 

  const [usuario_id, setUsuario_id] = useState(null);
  const { payload_vendedores } = route.params || {};

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [proprietarios, setProprietarios] = useState([
    {
      nomeCompleto: '',
      email_contratante: '',
      cpf_contratante: '',
      tel_contratante: '',
      cep_contratante: '',
      endereco_contratante: '',
      complemento_contratante: '',
      bairro_contratante: '',
      cidadeUf_contratante: '',
      estado_civil: '',
      nome_conjuge: '',
      nacionalidade_conjuge: '',
      rg_conjuge: '',
      ssp_rg_conjuge: '',
      cpf_conjuge: '',
      nacionalidade: '',
      rg_number: '',
      ssp_rg: '',
      erroNome: '',
    },
  ]);

  const nomeCompletoRef = useRef([]);
  const cpfRef = useRef([]);
  const cepRef = useRef([]);

  const atualizarProprietario = (index, campo, valor) => {
    const novosProprietarios = [...proprietarios];
    novosProprietarios[index][campo] = valor;
    setProprietarios(novosProprietarios);
  };

  const adicionarProprietario = () => {
    setProprietarios([
      ...proprietarios,
      {
        nomeCompleto: '',
        email_contratante: '',
        cpf_contratante: '',
        tel_contratante: '',
        cep_contratante: '',
        endereco_contratante: '',
        complemento_contratante: '',
        bairro_contratante: '',
        cidadeUf_contratante: '',
        estado_civil: '',
        nome_conjuge: '',
        nacionalidade_conjuge: '',
        rg_conjuge: '',
        ssp_rg_conjuge: '',
        cpf_conjuge: '',
        nacionalidade: '',
        rg_number: '',
        ssp_rg: '',
        erroNome: '',
      },
    ]);
  };

  const handleCepChange = (text, index) => {
    const formattedCep = text.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');
    atualizarProprietario(index, 'cep_contratante', formattedCep);
    if (formattedCep.length === 9) {
      atualizarEnderecoViaCep(formattedCep, index);
    }
  };

  const atualizarEnderecoViaCep = async (cep, index) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
      if (response.data) {
        const novosProprietarios = [...proprietarios];
        const p = { ...novosProprietarios[index] };

        // Atualiza com base no que foi retornado, mantendo campo editável
        p.endereco_contratante = response.data.logradouro || p.endereco_contratante;
        p.bairro_contratante = response.data.bairro || p.bairro_contratante;
        p.cidadeUf_contratante = `${response.data.localidade}/${response.data.uf}` || p.cidadeUf_contratante;

        novosProprietarios[index] = p;
        setProprietarios(novosProprietarios);
      }
    } catch (error) {
      Alert.alert('Erro', 'Não foi possível buscar o CEP');
    }
  };

  const isEmailValido = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isFormValid = () => {
    return proprietarios.every((p) => p.nomeCompleto && p.cpf_contratante && p.cep_contratante);
  };

  const handleSaveImovel = async () => {
    const contratantesFormatados = proprietarios.map((p) => {
      const [cidade, uf] = (p.cidadeUf_contratante || '').split('/');

      const base = {
        nome: p.nomeCompleto,
        cpf: p.cpf_contratante,
        rg_number: p.rg_number,
        ssp_rg: p.ssp_rg,
        estado_civil: p.estado_civil,
        endereco: `${p.endereco_contratante} ${p.complemento_contratante}`.trim(),
        telefone: p.tel_contratante,
        nacionalidade: p.nacionalidade || 'brasileiro(a)',
      };

      if (p.estado_civil.toLowerCase() === 'casado(a)') {
        return {
          ...base,
          nome_conjuge: p.nome_conjuge,
          nacionalidade_conjuge: p.nacionalidade_conjuge,
          rg_conjuge: p.rg_conjuge,
          ssp_rg_conjuge: p.ssp_rg_conjuge,
          cpf_conjuge: p.cpf_conjuge,
        };
      }

      return base;
    });

    navigation.navigate('EtapasPromessaWeb', { payload_vendedores, payload_compradores: contratantesFormatados, status: 3 });
    setIsSubmitting(true);

  };

  return (
    <BaseWeb>
      {(userInfo) => {
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados do(s) comprador(es)</Text>

              {proprietarios.map((p, index) => (
                <View key={index} style={styles.proprietarioContainer}>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Nome Completo</Text>
                    <TouchableWithoutFeedback onPress={() => nomeCompletoRef.current[index]?.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={(ref) => (nomeCompletoRef.current[index] = ref)}
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="Nome completo"
                          value={p.nomeCompleto}
                          placeholderTextColor="#A9A9A9"
                          onChangeText={(text) => {
                            atualizarProprietario(index, 'nomeCompleto', text);
                          }}
                          onBlur={() => {
                            const cleaned = (p.nomeCompleto || '').trim().replace(/\s+/g, ' ');
                            atualizarProprietario(index, 'nomeCompleto', cleaned);

                            const palavras = cleaned.split(' ');
                            if (palavras.length < 2) {
                              atualizarProprietario(index, 'erroNome', 'Informe o nome completo');
                            } else {
                              atualizarProprietario(index, 'erroNome', '');
                            }
                          }}
                        />
                      </View>
                    </TouchableWithoutFeedback>

                    {typeof p.erroNome === 'string' && p.erroNome.trim() !== '' && (
                      <Text style={styles.errorText} allowFontScaling={false}>
                        {p.erroNome}
                      </Text>
                    )}
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CPF</Text>
                    <MaskInput
                      ref={(ref) => (cpfRef.current[index] = ref)}
                      style={styles.areaInput}
                      value={p.cpf_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'cpf_contratante', text)}
                      mask={Masks.BRL_CPF}
                      placeholder="000.000.000-00"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>RG</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.rg_number}
                      onChangeText={(text) => atualizarProprietario(index, 'rg_number', text)}
                      placeholder="1234567"
                      keyboardType="numeric"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Órgão Emissor (SSP/UF)</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.ssp_rg}
                      onChangeText={(text) => atualizarProprietario(index, 'ssp_rg', text)}
                      placeholder="SSP-DF"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Nacionalidade</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.nacionalidade}
                      onChangeText={(text) => atualizarProprietario(index, 'nacionalidade', text)}
                      placeholder="brasileiro(a), etc"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Telefone</Text>
                    <MaskInput
                      style={styles.areaInput}
                      value={p.tel_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'tel_contratante', text)}
                      mask={Masks.BRL_PHONE}
                      placeholder="(00) 00000-0000"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="phone-pad"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Estado Civil</Text>
                    <TouchableWithoutFeedback
                      onPress={() => {
                        const updated = [...proprietarios];
                        updated[index].showEstadoCivilOptions = !updated[index].showEstadoCivilOptions;
                        setProprietarios(updated);
                      }}
                    >
                      <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                        <Text style={{ color: '#1F2024' }}>
                          {p.estado_civil ? p.estado_civil : 'Selecionar'}
                        </Text>
                      </View>
                    </TouchableWithoutFeedback>



                    {p.showEstadoCivilOptions && (
                      <View style={styles.optionsContainer}>
                        {['solteiro(a)', 'casado(a)', 'viúvo(a)', 'divorciado(a)', 'separado(a)'].map((option) => (
                          <TouchableOpacity
                            key={option}
                            style={styles.optionItem}
                            onPress={() => {
                              const updated = [...proprietarios];
                              updated[index].estado_civil = option;
                              updated[index].showEstadoCivilOptions = false;
                              setProprietarios(updated);
                            }}
                          >
                            <Text style={styles.optionText}>{option}</Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    )}
                  </View>

                  {p.estado_civil.toLowerCase() === 'casado(a)' && (
                    <>
                      <View style={styles.row}>
                        <Text style={styles.subLabel}>Nome do cônjuge</Text>
                        <TextInput
                          style={styles.areaInput}
                          value={p.nome_conjuge}
                          onChangeText={(text) => atualizarProprietario(index, 'nome_conjuge', text)}
                          placeholder="Nome completo"
                          placeholderTextColor="#A9A9A9"
                        />
                      </View>

                      <View style={styles.row}>
                        <Text style={styles.subLabel}>Nacionalidade do cônjuge</Text>
                        <TextInput
                          style={styles.areaInput}
                          value={p.nacionalidade_conjuge}
                          onChangeText={(text) => atualizarProprietario(index, 'nacionalidade_conjuge', text)}
                          placeholder="brasileira, etc"
                          placeholderTextColor="#A9A9A9"
                        />
                      </View>

                      <View style={styles.row}>
                        <Text style={styles.subLabel}>RG do cônjuge</Text>
                        <TextInput
                          style={styles.areaInput}
                          value={p.rg_conjuge}
                          onChangeText={(text) => atualizarProprietario(index, 'rg_conjuge', text)}
                          placeholder="1234567"
                          placeholderTextColor="#A9A9A9"
                        />
                      </View>

                      <View style={styles.row}>
                        <Text style={styles.subLabel}>SSP do cônjuge</Text>
                        <TextInput
                          style={styles.areaInput}
                          value={p.ssp_rg_conjuge}
                          onChangeText={(text) => atualizarProprietario(index, 'ssp_rg_conjuge', text)}
                          placeholder="SSP-DF"
                          placeholderTextColor="#A9A9A9"
                        />
                      </View>

                      <View style={styles.row}>
                        <Text style={styles.subLabel}>CPF do cônjuge</Text>
                        <MaskInput
                          style={styles.areaInput}
                          value={p.cpf_conjuge}
                          onChangeText={(text) => atualizarProprietario(index, 'cpf_conjuge', text)}
                          mask={Masks.BRL_CPF}
                          placeholder="000.000.000-00"
                          placeholderTextColor="#A9A9A9"
                          keyboardType="numeric"
                        />
                      </View>
                    </>
                  )}


                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CEP</Text>
                    <TextInput
                      ref={(ref) => (cepRef.current[index] = ref)}
                      style={styles.areaInput}
                      value={p.cep_contratante}
                      onChangeText={(text) => handleCepChange(text, index)}
                      placeholder="00.000-000"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                      maxLength={9}
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Endereço</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.endereco_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'endereco_contratante', text)}
                      placeholder="Rua, Avenida..."
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Complemento</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.complemento_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'complemento_contratante', text)}
                      placeholder="Apto, Bloco..."
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Bairro</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.bairro_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'bairro_contratante', text)}
                      placeholder="Bairro"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Cidade/UF</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.cidadeUf_contratante}
                      onChangeText={(text) => atualizarProprietario(index, 'cidadeUf_contratante', text)}
                      placeholder="Cidade/UF"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>


                  {proprietarios.length > 1 && (
                    <TouchableOpacity
                      onPress={() => {
                        const novaLista = proprietarios.filter((_, i) => i !== index);
                        setProprietarios(novaLista);
                      }}
                      style={{ alignSelf: 'flex-end', marginBottom: 10 }}
                    >
                      <Text style={{ color: 'red', fontWeight: 'bold' }}>Remover</Text>
                    </TouchableOpacity>
                  )}
                  <View style={styles.divider} />
                </View>
              ))}
              {/* Inputs de Área */}

              <TouchableOpacity style={styles.laterButton} onPress={adicionarProprietario}>
                <Text style={styles.laterButtonText}>Adicionar contratante</Text>
              </TouchableOpacity>
              {/* Botão Salvar */}
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSaveImovel}
                  disabled={!isFormValid() || isSubmitting} // Desabilita durante a submissão
                >
                  <Text style={styles.saveButtonText} allowFontScaling={false}>
                    {isSubmitting ? "Enviando..." : "Salvar"}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity style={styles.laterButton}>
                  <Image
                    source={require('../../../assets/icons/bookmark.png')} // Ícone de terminar mais tarde
                    style={styles.laterIcon}
                  />
                  <Text
                    style={styles.laterButtonText}
                    allowFontScaling={false}
                    onPress={() => navigation.navigate('Home', { usuario_id })}
                  >
                    Terminar mais tarde
                  </Text>
                </TouchableOpacity>
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
